
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/marketo",
      function () {
        return require("private-next-pages/destinations/marketo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/marketo"])
      });
    }
  